import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DisplayDeviceContent from './DisplayDeviceContent';
import LiveVideoStream from './LiveVideoStream';
import './Popup.css';
import ActiveAlertsContainer from './ActiveAlertsContainer';
import { customSortFunction } from './Update';
import share from '../assets/share.svg';
import Popup from './Popup';
import SharedLinkComponent from './ShareLinkComponent';
import SharedLinkInfo from './SharedLinkInfo';

function AddressTab(props) {
  const deviceList = useSelector((state) => state.userInfo.deviceList);
  const selectedRoomId = useSelector((state) => state.userInfo.selectedRoomId);
  const devicesOrder = useSelector((state) => state.userInfo.devicesOrder);
  const [cameraList, setCameraList] = useState([]);
  const [sharePopup, setSharePopup] = useState(false);
  const [sharedLinks, setSharedLinks] = useState(false);

  useEffect(() => {
    // list of cameras
    const cameras = deviceList?.devices?.filter(
      (device) => device?.roomId === selectedRoomId && device?.insert?.type.toLowerCase() === 'video',
    );
    setCameraList(cameras ?? []);
  }, [deviceList, selectedRoomId]);

  // display online inserts (except cameras) in devices section
  const displayAllSensors = (deviceList) => {
    const allSensors = deviceList?.devices?.filter(
      (device) => device?.roomId === selectedRoomId && device?.insert?.type.toLowerCase() !== 'video',
    );

    if (allSensors && allSensors.length) allSensors.sort((firstElement, secondElement) => customSortFunction(devicesOrder[firstElement.deviceId], devicesOrder[secondElement.deviceId], 'asc'));

    return (
      allSensors?.length
        ? allSensors?.map((device) => (
          <DisplayDeviceContent key={device.deviceId} device={device} />
        ))
        : null
    );
  };

  const openSharePopup = () => {
    setSharePopup(true);
  };

  const closeSharePopup = () => {
    setSharePopup(false);
  };

  const getCameraComponent = (cameraList) => (
    cameraList?.length
      ? (
        <div className="video-wrapper">
          {cameraList?.map((camera) => (
            <div key={camera.thingName}>
              <LiveVideoStream
                key={camera.thingName}
                thingName={camera.thingName}
                device={camera}
                showInfo
              />
            </div>
          ))}
        </div>
      )
      : null
  );

  return (
    <div>
      <div className="content">
        <SharedLinkInfo setSharedLinks={setSharedLinks} />
        <h2 className="mb-05">Devices</h2>

        <div className="white-wrapper">
          { cameraList?.length > 0
          && (
          <button className="primary-btn share-btn" onClick={openSharePopup}>
            Share &nbsp;
            <img src={share} alt="share" className="clickable" />
          </button>
          )}
          {sharePopup && <Popup closePopup={closeSharePopup} title="Share Camera Feed" child={<SharedLinkComponent />} />}
          {!sharedLinks
            ? getCameraComponent(cameraList)
            : (
              <>
                <h3 className="mb-1 black">The video stream is currently unavailable; a shared link is currently in use</h3>
                <video style={{ width: '100%', backgroundColor: '#000000' }} />
              </>
            )}
          <div className="sensor-wrapper">
            {displayAllSensors(deviceList)}
          </div>
        </div>

        <ActiveAlertsContainer
          setAlertLoading={props.setAlertLoading}
          setSelectedEvent={props.setSelectedEvent}
        />

      </div>
    </div>
  );
}

export default AddressTab;
